import * as z from 'zod';
export const Status = z.enum(['active', 'inactive']);
//# sourceMappingURL=schemas.js.map